module.exports = __webpack_public_path__ + "media/images/webpage/coupons/shared/merit3-c5c9a5e6d12418bfc37e5896c8a135ac.svg";